import { HtmlHTMLAttributes } from 'react';

import { HTMLDataTrackerProps } from '@/app/types';
import { cn } from '@/lib/utils';

export const headingLevels = [
  'xl',
  'l',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
] as const;
export interface HeadingProps {
  level: (typeof headingLevels)[number];
  classNames?: {
    root?: string;
  };
}

type HeadingWithHtmlProps = HeadingProps &
  HTMLDataTrackerProps &
  HtmlHTMLAttributes<HTMLHeadingElement> & {
    children: React.ReactNode;
  };

const HeadingStyles = {
  xl: 'text-xl',
  l: 'text-l',
  h1: 'text-h1',
  h2: 'text-h2',
  h3: 'text-h3',
  h4: 'text-h4',
  h5: 'text-h5',
  h6: 'text-h5',
} as const;

export const getHeadingElement = (level: HeadingProps['level']) => {
  return (['xl', 'l'].includes(level) ? 'h1' : level) as
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6';
};

export default function Heading({
  children,
  level = 'h1',
  classNames,
  ...rest
}: HeadingWithHtmlProps) {
  const HeadingEl = getHeadingElement(level);
  const headingClass = HeadingStyles[level];

  return (
    <HeadingEl
      className={cn(headingClass, 'font-serif text-gray-950', classNames?.root)}
      data-tracker-component='heading'
      {...rest}
    >
      {children}
    </HeadingEl>
  );
}
